<template>
  <div>
    <!-- image -->
    <div v-if="pageMode === 'image' && !all">
      <eco-flow-map :card="mode === 'list'" @node="onClickEcoFlow"/>
    </div>

    <div v-else>
      <div class="p-3 flex items-center" >
        <h4 v-if="all" style="cursor:pointer;">전체</h4>
        <h4 v-else style="cursor:pointer;" @click="onClickBack">{{ selectNodeName }}</h4>
      </div>
      <!-- search -->
      <search-nav @handleSearch="onClickSearch">
        <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex ">
          <component
            v-for="(component, index) in stdSearchComponents"
            v-if="showSearchNavItem(component['options'])"
            :is="component['component']"
            :label="component['label']"
            :query="component['query']"
            :options="component['options']"
            :onClickSearch="onClickSearch"
            v-model="nav.value[component['value']]"
          />
        </div>
      </search-nav>

      <!-- list -->
      <div >
        <fragment v-if="mode === 'popup'">
          <div class="w-full flex">
            <div class="flex mr-auto mb-4">
              <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px;" >
                <vs-select-item v-for="v in [10, 20, 30, 50]" :text="`${v}개씩 보기`" :value="v" />
              </vs-select>
            </div>
            <div v-if="!all" class="flex ml-auto gap-2">
              <vs-button color="secondary" type="border" class="mb-4 flex-1 xl:flex-none py-1">
                <div class="flex items-end" @click="onClickBack">
                  <feather-icon icon="ChevronLeftIcon"/>
                  <span style="padding-bottom: 2px">공정별 분류표</span>
                </div>
              </vs-button>
            </div>
          </div>
        </fragment>
        <fragment v-else>
          <div class="w-full grid md:flex">
            <div class="flex mr-auto mb-4 order-3 md:order-1">
              <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px;" >
                <vs-select-item v-for="v in [10, 20, 30, 50]" :text="`${v}개씩 보기`" :value="v" />
              </vs-select>
            </div>
            <div class="grid md:flex ml-0 md:ml-auto gap-2 order-2 mb-4">
              <vs-button color="secondary" type="border" class="xl:flex-none py-1">
                <div class="flex items-end" @click="onClickBack">
                  <feather-icon icon="ChevronLeftIcon"/>
                  <span style="padding-bottom: 2px">공정별 분류표</span>
                </div>
              </vs-button>
              <vs-button color="secondary" type="border" class="xl:flex-none" @click="showExcelDownload = true">엑셀 다운로드</vs-button>
              <vs-button color="secondary" class="xl:flex-none" @click="onClickNew">신규작성</vs-button>
            </div>
          </div>
        </fragment>
        <div class="list">
          <div class="list-header list-grid">
            <div>No.</div>
            <div>공정명</div>
            <div>사업장명</div>
            <div>공정번호</div>
            <div>관리번호</div>
            <div>시설명</div>
            <div>용량</div>
          </div>
          <div class="list-body">
            <div v-for="(data, index) in list"
                 class="list-grid"
                 :class="{'active': mode === 'popup' && data.id === selectData.id,
                        'cursor-pointer': mode === 'popup'}"
                 @click="onClickDetail(data)">
              <template>
                <div>{{ (page - 1) * perPage + index + 1 }}</div>
                <div>{{ data.body.시설정보 ? ecoFlow.getLabel(data.body.시설정보.공정명) : ''}}</div>
                <div>{{ data.body.stdInfo ? data.body.stdInfo.field_name : '' }}</div>
                <div>{{ data.body.시설정보 ? data.body.시설정보.공정번호 : ''}}</div>
                <div>{{ data.body.시설정보 ? data.body.시설정보.관리번호 : ''}}</div>
                <div>{{ data.body.시설정보 ? data.body.시설정보.시설명 : ''}}</div>
                <div>{{ data.body.시설정보 ? data.body.시설정보.용량 : ''}}</div>
              </template>

            </div>
          </div>

          <div v-if="!list || list.length === 0" class="border-bottom">
            <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px">
              <feather-icon icon="AlertTriangleIcon" class="mr-2" />
              표시할 데이터가 없습니다.
            </div>
          </div>
        </div>

        <div class="vs-con-table">
          <div class="con-pagination-table vs-table--pagination">
            <k-pagination :total="lastPage ? lastPage : 0" v-model="page" @change="onChangePage"></k-pagination>
          </div>
        </div>
      </div>
    </div>

    <div v-if="mode === 'popup'" class="flex justify-end gap-4">
      <vs-button color="#DCDFE2" text-color="black" @click="$emit('close')">닫기</vs-button>
      <vs-button color="secondary" @click="$emit('select', selectData)">등록</vs-button>
    </div>

    <popup-excel-download
      v-model="showExcelDownload"
      :list="getExcelList"
      :title="getExcelFileName"/>
  </div>
</template>

<script>

import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import List from "./List.js";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";
import EcoFlowMap from "@/views/boards/single-page/977/EcoFlowMap.vue";
import ecoFlow from "@/views/boards/single-page/977/ecoFlow";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";

export default {
  components: {
    PopupExcelDownload,
    EcoFlowMap,
    KPagination,
    SearchColumnKeyword,
    SearchNav
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
    mode: {
      type: String,
      default: "list"
    },

    // tab/977 과 동일하게 전체 환경시설을 검색할 수 있도록함.
    // table-list-page 를 사용해야 했으나, 추가되는 내용이 많아 Page.vue 로 처리
    all: Boolean,
  },
  computed: {
    ecoFlow() {
      return ecoFlow
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return 977;
    },
    stdSearchComponents() {
      const getComponents = List.components
      if (getComponents) {
        const stdSearchComponents = getComponents();
        if (stdSearchComponents && stdSearchComponents.length > 0) {
          for (const component of stdSearchComponents) {
            component.component = searchComponent[component['component']];

            // 이미지 페이지에서 공정명을 선택하므로, 검색조건에서는 제외
            if (!this.all && this.selectEcoFlowId) {
              component.options.hiddenList = ["공정명", "작성일"]
            }
          }
        }
        return stdSearchComponents;
      }
      return [];
    },
    selectNodeName () {
      return ecoFlow.getLabel(this.selectEcoFlowId)
    },

    getExcelFileName() {
      return `환경시설분류_${ecoFlow.getLabel(this.selectEcoFlowId)}`;
    },
    getExcelList() {
      return this.list ? this.list.map((data) => {
        return {
          'No.': (this.page - 1) * this.perPage + this.list.indexOf(data) + 1,
          '공정명': data.body.시설정보 ? ecoFlow.getLabel(data.body.시설정보.공정명) : '',
          '사업장명': data.body.stdInfo ? data.body.stdInfo.field_name : '',
          '공정번호': data.body.시설정보 ? data.body.시설정보.공정번호 : '',
          '관리번호': data.body.시설정보 ? data.body.시설정보.관리번호 : '',
          '시설명': data.body.시설정보 ? data.body.시설정보.시설명 : '',
          '용량': data.body.시설정보 ? data.body.시설정보.용량 : '',
        }
      }) : []
    }
  },
  watch : {
    perPage () {
      this.loadListBoard()
    },
    all: {
      immediate: true,
      handler(all) {
        // 공정별 탭에서는 공정명이 조건에서 제외 되므로, 전체 환경시설과 다르게 처리
        if (all) {
          this.nav.value.column = { head: '공정명', keyword: '' }
        } else {
          this.nav.value.column = { head: '사업장명', keyword: '' }
        }
        this.loadListBoard()
      }
    }
  },
  data() {
    return {
      nav: {
        value: {},
      },
      askForDelete: true, // 삭제 확인창
      selectData: {
        id: 0
      }, // 선택한 데이터 (popup 모드일 때 사용가능)

      pageMode: 'image', // 공정별 분류표 이미지 모드
      selectEcoFlowId: '', // 선택 공정
      showExcelDownload: false,

      page: 1,
      lastPage: 1,
      perPage: 20,
      total: 0,
      list:[],
    };
  },
  created() {
    if (this.$route.query.p) {
      this.pageMode = 'list';
      this.selectEcoFlowId = this.$route.query.p;
    }
  },
  methods: {
    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    async loadListBoard () {

      const conditions = List.getConditions(this.nav);
      const options = {
        projectId: this.projectId,
        boardId: this.boardId,
        page: this.page,
        perPage: this.perPage,
        conditions,
      }

      if (!this.all) {
        conditions.push({ key: 'body.시설정보.공정명', operator: "LIKE", value: this.selectEcoFlowId });
      }

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);

      this.list = response.data.map((data) => {return {id: data.id, ...JSON.parse(data.post_content)}});
      this.total = response.total;
      this.lastPage = response.last_page;
      this.page = (this.page > this.lastPage) ? this.lastPage : this.page
    },
    onClickEcoFlow (selectEcoFlowId) {
      this.pageMode = 'list';
      this.selectEcoFlowId = selectEcoFlowId;
    },
    onClickSearch () {
      this.page = 1
      this.loadListBoard()
    },
    onChangePage (page) {
      this.page = page
      this.loadListBoard()
    },
    onClickNew () {
      this.$router.push({
        name: 'write|tab',
        params: {
          projId: this.projectId,
          boardId: this.boardId,
          pageType: 'write',
        },
        query: {
          _t_back: '977/page',
          p: this.selectEcoFlowId,
        }
      })
    },
    onClickDetail(data) {
      if (this.mode === 'popup') {
        this.selectData = data
        return
      }

      this.$router.push({
        name: 'write|update|tab',
        params: {
          projId: this.projectId,
          boardId: this.boardId,
          pageType: 'write',
          postId: data.id,
        },
        query: {
          _t_back: '977/page',
          p: this.selectEcoFlowId,
        }
      })
      this.selectData = data
    },
    onClickBack() {
      const query = this.$route.query;
      delete query.p;

      this.pageMode = 'image'

      if (`${this.$route.query}` === '{}') {
        this.$router.replace({'query': null});
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  width: 100%;
  overflow-x: auto;
  text-align: center;

  .list-header {
    font-weight: 700;

    & > div {
      background-color: #f5f5f5;
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
    }
  }
  .list-body {
    & > div > div { background-color: #ffffff; border-bottom: 1px solid #e0e0e0; cursor: pointer}
    & > div:hover { background-color: #f5f5f5; color: #000; font-weight: bold }
    & > div.active { background-color: #7E72F299; color: #fff }
  }

  .list-grid {
    display: grid;
    grid-template-columns: minmax(63px, 0.25fr) repeat(6, minmax(140px, 1fr));

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }



  &.update {
    .list-grid {
      grid-template-columns: repeat(6, minmax(140px, 1fr)) 94px;
    }
    .list-edit {
      display: flex;
    }
  }
}
</style>
